import { Loader2 } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Loading state component for interview initialization
 */
export const LoadingState = () => {
  return (
    <div className="flex flex-col flex-grow items-center justify-center">
      <div className="flex flex-col items-center p-8 bg-white rounded-xl shadow-md">
        <Loader2 className="h-12 w-12 text-blue-500 animate-spin mb-4" />
        <h3 className="text-lg font-medium text-gray-900">Loading Behavioral Interview...</h3>
        <p className="text-gray-500 mt-2">Preparing your interview experience</p>
      </div>
    </div>
  );
};

/**
 * Error state component with retry option
 */
export const ErrorState = ({ error, onRetry }) => {
  return (
    <div className="flex flex-col flex-grow items-center justify-center">
      <div className="flex flex-col items-center p-8 bg-white rounded-xl shadow-md border border-red-100">
        <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900">Error</h3>
        <p className="text-gray-500 mt-2">{error}</p>
        <button
          onClick={onRetry}
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

ErrorState.propTypes = {
  error: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired,
};
